import { SimpleActivity } from "@ac-expo/api-types";
import { Button } from "@ac-expo/ui-components";
import { isTicketingAvailable, isTicketTypeWithinSalePeriod } from "@ac-expo/utils";
import { format, isAfter } from "date-fns";
import { FC } from "react";
import ProtectedButton from "../Auth/components/ProtectedButton";

type ActivityRegisterButtonProps = {
  activity: SimpleActivity;
};

export const ActivityRegisterButton: FC<ActivityRegisterButtonProps> = ({
  activity,
}) => {
  const availableTicketTypes = activity?.ticketTypes?.filter(isTicketTypeWithinSalePeriod) ?? [];
  const activityTicketType = availableTicketTypes.at(0);
  const now = format(new Date(), "yyyy-MM-dd");

  const isRegisterEnabled =
    activity &&
    (isTicketingAvailable(activity.event) ||
      activity.schedules.some((s) => isAfter(s.timetable.day, now))) &&
    activityTicketType !== undefined;

  if (!isRegisterEnabled) {
    return null;
  }

  return (
    <ProtectedButton>
      <Button variant={"outline-white"} className="border-blue-500 text-blue-500">
        S&apos;inscrire
      </Button>
    </ProtectedButton>
  );
};
